<template>
	<div>
		<titles titlename="数据墙" titlecontent="这里可以看到数据可视化分析" :mbx="paths"></titles>
		<filters :rooms="filterslist"></filters>
		<div class="contentbox" v-if="schoollist.length > 0">
			<!-- v-for="(item,index) in datalist" :key="index" -->
			<!-- <el-empty v-if="datalist.length == 0" description="暂无数据分析"></el-empty> -->
			<ul v-if="siguid != 'f8c6d6c6a9a348deba161a1c77d31e15'">
				<li class="col-xs-12 col-sm-5 col-md-5 col-lg-3" @click="godatawal" v-if="islistmune">
					<div style="overflow: hidden;"><img src="../images/datawall.jpg" alt="" /></div>
					<div style="display: flex;align-items: center;justify-content: space-between;padding: 0 0.4rem;">
						<p class="titimes" style="margin-right: 1rem;">大屏可视化数据</p>
						<p class="titimes">{{ schoolbname }}</p>
					</div>
					<span class="contentc">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 数据大屏是为了更好的查看分析数据，当前大屏数据主要是为了分析和统计学生预约实训！</span>
				</li>

				<li class="col-xs-12 col-sm-5 col-md-5 col-lg-3" @click="godatawals" v-if="islistmune1">
					<div style="overflow: hidden;"><img src="../images/datawall1.jpg" alt="" /></div>
					<div style="display: flex;align-items: center;justify-content: space-between;padding: 0 0.4rem;">
						<p class="titimes" style="margin-right: 1rem;">学员实训技能画像</p>
						<p class="titimes">{{ schoolbname }}</p>
					</div>
					<span class="contentc">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 数据大屏是为了更好的查看分析数据，当前大屏数据学生预约实训！</span>
				</li>

				<!-- <li class="col-xs-12 col-sm-5 col-md-5 col-lg-3" @click="godatawals" v-if="islistmune2">
					<div style="overflow: hidden;"><img src="../images/datawall1.jpg" alt="" /></div>
					<div style="display: flex;align-items: center;justify-content: space-between;padding: 0 0.4rem;">
						<p class="titimes" style="margin-right: 1rem;">高铁时代云平台数据汇总</p>
						<p class="titimes">{{ schoolbname }}</p>
					</div>
					<span class="contentc">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 数据大屏是为了更好的查看分析数据，当前大屏数据为高铁时代云平台所有学校实训成绩汇总！</span>
				</li> -->
			</ul>

			<ul v-else>
				<li class="col-xs-12 col-sm-5 col-md-5 col-lg-3" style="cursor: pointer;" @click="godatawalmoni(1)">
					<div style="overflow: hidden;"><img src="@/assets/images/drivedatawall.png" alt="" /></div>
					<div style="display: flex;align-items: center;justify-content: space-between;padding: 0 0.4rem;">
						<p class="titimes" style="margin-right: 1rem;">模拟驾驶大屏可视化数据</p>
						<p class="titimes">{{ schoolbname }}</p>
					</div>
					<span class="contentc">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 数据大屏是为了更好的查看分析数据，当前大屏数据主要是为了分析和统计学生预约实训！</span>
				</li>

				<li class="col-xs-12 col-sm-5 col-md-5 col-lg-3" style="cursor: pointer;" @click="godatawalmoni(2)">
					<div style="overflow: hidden;"><img src="@/assets/images/drivedatawalluser.png" alt="" /></div>
					<div style="display: flex;align-items: center;justify-content: space-between;padding: 0 0.4rem;">
						<p class="titimes" style="margin-right: 1rem;">学员实训技能画像</p>
						<p class="titimes">{{ schoolbname }}</p>
					</div>
					<span class="contentc">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 数据大屏是为了更好的查看分析数据，当前大屏数据主要是为了分析和统计学生预约实训！</span>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';
import filters from '@/components/filters/walldatafilter.vue';
import { GetbjGetSchoolList } from '@/request/api/mange/mange.js';
import AppOptions from '@/config/AppOptions.vue';
export default {
	data() {
		return {
			// 标题组件
			paths: [
				{
					path: '/datawall',
					name: '数据墙'
				}
			],
			schoollist: [],
			siguid: '',
			schoolbname: '',
			datalist: [],
			islistmune: false,
			islistmune1: false,
			islistmune2: false,
			filterslist: {
				name: '数据墙',
				content: '',
				filterlist: [
					{
						id: 0,
						indexsshol: 0,
						title: '所属院校',
						childers: []
					}
				]
			}
		};
	},
	beforeMount() {
		this.getscool();
		let lookmenulist = [];
		if (this.$cookie.get('lookinmune')) {
			lookmenulist = JSON.parse(this.$cookie.get('lookinmune'));
			lookmenulist.forEach(item => {
				if (item.mu_name_en == 'glycharts') {
					this.islistmune = true;
				} else if (item.mu_name_en == 'studentdatawall') {
					this.islistmune1 = true;
				} else if (item.mu_name_en == 'superuserdaaping') {
					this.islistmune2 = true;
				}
			});
		} else if (localStorage.getItem('lookinmune')) {
			lookmenulist = JSON.parse(localStorage.getItem('lookinmune'));
			lookmenulist.forEach(item => {
				if (item.mu_name_en == 'glycharts') {
					this.islistmune = true;
				} else if (item.mu_name_en == 'studentdatawall') {
					this.islistmune1 = true;
				} else if (item.mu_name_en == 'superuserdaaping') {
					this.islistmune2 = true;
				}
			});
		}

		// console.log(JSON.parse(lookmenulist))
	},
	created() {
		AppOptions.appEmpty = false;
	},
	updated() {},
	methods: {
		// 前往模拟驾驶
		godatawalmoni(num) {
			if (num == 1) {
				let routerurl1 = this.$router.resolve({
					path: '/datawall/driveschooldata?siguid=' + this.siguid
				});

				window.open(routerurl1.href, '_blank');
			} else {
				let routerurl = this.$router.resolve({
					path: '/datawall/driveschooldatauser?siguid=' + this.siguid
				});

				window.open(routerurl.href, '_blank');
			}
		},

		changeschoolif(item) {
			this.siguid = item.si_guid;
			this.schoolbname = item.si_name_cn;
		},
		getscool() {
			GetbjGetSchoolList().then(res => {
				// console.log(res, "院校不分页")
				this.schoollist = JSON.parse(JSON.stringify(res.data.data));
				this.schoollist.forEach(item => {
					item.name = item.si_name_cn;
				});
				this.siguid = this.schoollist[0].si_guid;
				this.schoolbname = this.schoollist[0].si_name_cn;

				this.filterslist.filterlist[0].childers = this.schoollist;
			});
		},
		godatawals() {
			let routerurl = this.$router.resolve({
				path: '/datawall/datawalluser?siguid=' + this.siguid
			});

			window.open(routerurl.href, '_blank');
		},
		godatawal() {
			let routerurl = this.$router.resolve({
				path: '/datawall/schooldata?siguid=' + this.siguid
			});

			window.open(routerurl.href, '_blank');
		}
	},
	components: {
		titles,
		filters
	}
};
</script>

<style scoped lang="less">
.contentbox {
	width: 100%;
	height: 400px;
	margin: 1rem 0;
	padding: 1rem;
	background-color: #fff;

	ul {
		// background-color: #f5f5f5;
		overflow: hidden;
		// margin: 20px 0;
		height: 100%;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;

		@media (min-width: 992px) {
			.col-lg-3 {
				-webkit-box-flex: 0;
				-ms-flex: 0 0 auto;
				flex: 0 0 auto;
				width: 24% !important;
			}

			li:last-child:nth-child(4n + 2) {
				// background-color: orange;
				margin-right: calc((100% - 24%) / 3 * 2);
			}

			li:last-child:nth-child(4n + 3) {
				// background-color: pink;
				margin-right: calc((100% - 24%) / 3 * 1);
			}
		}

		li:hover {
			box-shadow: 2px 6px 10px 0;
		}

		li {
			height: 95%;
			box-sizing: border-box;
			background: #fff;
			border-radius: 2px;
			// margin: 1rem 0;
			position: relative;
			padding: 0 0 1rem 0;
			border: 1px solid #ccc;

			overflow: hidden;

			.titimes {
				font-size: 0.8rem;
				color: #333;
				margin: 1rem 0 0.5rem 0.5rem;
				font-weight: 700;
				overflow: hidden;
				text-overflow: ellipsis;
			}

			img {
				width: 100%;
				height: 16rem;
				object-fit: cover;
				transition: 0.8s;
			}

			#zzc {
				width: 100%;
				height: 16rem;
				background: rgba(0, 0, 0, 0.4);
				position: absolute;
				top: 0;
				display: none;
				cursor: pointer;
				line-height: 16rem;
				text-align: center;

				span {
					font-size: 3vw;
					color: #faad39;
					margin: 1rem 0;
				}

				span:first-child {
					// margin-top: 0 !important;
					margin: 0;
				}
			}

			.contentc {
				display: inline-block;
				// width: 100%;
				margin: 0 0.5rem;
				overflow: hidden;
				text-overflow: ellipsis;
				/* 超出部分省略号 */
				word-break: break-all;
				/* break-all(允许在单词内换行。) */
				display: -webkit-box;
				/** 对象作为伸缩盒子模型显示 **/
				-webkit-box-orient: vertical;
				/** 设置或检索伸缩盒对象的子元素的排列方式 **/
				-webkit-line-clamp: 3;
				/** 显示的行数 **/
			}

			button:hover {
				color: #fff !important;
				background: #1caf9a;
			}

			.roomsbutton {
				text-align: left;
				width: 95%;
				border-radius: 10px;
				margin: 1rem 0.6rem;
				display: flex;
				align-items: center;
				justify-content: space-between;

				.changeox {
					margin-right: 1rem;
					width: 1rem;

					input[type='checkbox'] {
						width: 100%;
						height: 1.4em;
						background-color: #dcdce3;
						border: 1px solid #ccc;
					}

					input[type='checkbox']:checked {
						background-color: #003e6d;
					}
				}

				span {
					margin-left: 5px;
				}

				button {
					padding: 0.6rem 0.8rem;
					border: 1px solid #ccc;
					border-radius: 5px;
					color: #999999;
					translate: all 2s;
				}
			}
		}
	}
}
</style>
